<template>
  <section class="editor-price-details-promotion flex flex-col gap-025 py-100 px-100 rounded-s">
    <p class="paragraph-bold" data-testid="price-details-promotion-title">{{ title }}</p>
    <p class="caption-regular text-secondary-secondary">
      {{ $t('editor.pricedetails.promotion.hint') }}
    </p>
  </section>
</template>

<script lang="ts" setup>
type Props = {
  title: string
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.editor-price-details-promotion {
  border: token('size/border/100') dashed token('color/border/accent/success/success');
  background: linear-gradient(
    90deg,
    token('color/background/primary/primary') 0%,
    token('color/green/100') 100%
  );
}
</style>
